import type { ReactNode } from 'react'
import logoText from '@/assets/logo/logo-text.svg'
import { cn } from '@/lib/utils'

export interface LogoProps {
  className?: string

  alt?: string
}

export const LogoText: React.FC<LogoProps> = ({ className, alt = 'SAAGA SOLVE' }): ReactNode => (
  <img src={logoText} alt={alt} className={cn('logo-full h-5 w-auto', className)} />
)
